// extracted by mini-css-extract-plugin
export default {"wrapper":"Level_wrapper__iGZrU","quesion-num":"Level_quesion-num__0t6JJ"};